import React from 'react';

const SpotListItemPlaceholder = () => {
    return (
        <div className="SpotListItemPlaceholder">
            <div className="SpotListItemPlaceholder-img" />
            <div className="SpotListItemPlaceholder-info">
                <div className="SpotListItemPlaceholder-address1" />
                <div className="SpotListItemPlaceholder-address2" />
                <div className="SpotListItemPlaceholder-amenities">
                    <div className="SpotListItemPlaceholder-amenity" />
                    <div className="SpotListItemPlaceholder-amenity" />
                </div>
            </div>
        </div>
    );
};

export default SpotListItemPlaceholder;
